import React, { useState } from 'react';

import { PVBlack } from '@pv/common/colors';
import { Box } from '@mui/material';

import { MobileFilterBarDialog } from './MobileFilterBarDialog';
import { MapPin, Calendar } from 'react-feather';
import { MobileFilterBarButton } from './MobileFilterBarButton';
import { getCapacityText, displayDateAndTime } from './utils';
import { useFilterBarContext } from './providers/FilterBarProvider';

interface MobileFilterBarProps {
  hasLocationSearch: boolean;
}

export const MobileFilterBar = ({
  hasLocationSearch,
}: MobileFilterBarProps) => {
  const {
    locationQuery,
    eventDate,
    startTime,
    endTime,
    capacityFilterValues,
  } = useFilterBarContext();
  const [open, setOpen] = useState(false);
  const handleClick = () => setOpen(true);
  const handleClose = () => setOpen(false);
  
  const dateAndTimeText = displayDateAndTime(eventDate, startTime, endTime);
  const capacityFilterText = getCapacityText(capacityFilterValues);
  const showLocationQuery = hasLocationSearch && !eventDate && !startTime && !endTime;
  let filterText: string[];
  let startIcon: React.ReactNode;
  
  if (showLocationQuery) {
    // Location search mode - show location query and capacity
    filterText = [locationQuery || '', capacityFilterText];
    startIcon = <MapPin color={PVBlack} />;
  } else {
    // Availability mode - show date/time and capacity
    filterText = [dateAndTimeText, capacityFilterText];
    startIcon = <Calendar color={PVBlack} />;
  }

  return (
    <Box role="search" style={{ flexGrow: 1 }}>
      <MobileFilterBarButton
        startIcon={startIcon}
        filterText={filterText}
        onClick={handleClick}
      />
      <MobileFilterBarDialog
        isOpen={open}
        onClose={handleClose}
        hasLocationSearch={hasLocationSearch}
      />
    </Box>
  );
};
